module.exports = __webpack_public_path__ + "static/media/whatsapp.f38ef564.svg";